import React, { useContext, useEffect, useState } from "react";
import { useAuthContext } from "../../../../contexts/AuthContext.jsx";
import { getStats } from "../../../SF";
import "../../../../stats.css";
import StatComponent from "../StatComponent";
import SkeletonLoader from "../../../UI/SkeletonLoader";

function StatsLastMonth() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const context = useAuthContext();

  useEffect(() => {
    if (!context || !context.user) return;
    setLoading(true);
    getStats(context, "Last Month")
      .then((result) => {
        setData(result);
      })
      .finally(() => setLoading(false));
  }, [context]);

  if (!context || !context.user) return null;

  const getMonthName = () => {
    const date = new Date();
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const lastMonth = monthNames[(date.getMonth() - 1 + 12) % 12];
    return lastMonth;
  };

  const hasStats = data && data.Stats && Object.keys(data.Stats).length > 0;

  return (
    <div>
      {loading && (
        <div className="skeleton-grid">
          <SkeletonLoader type="card" count={4} />
          <SkeletonLoader type="card" count={3} />
        </div>
      )}
      {!loading && hasStats && (
        <StatComponent stats={data} title={getMonthName()} />
      )}
      {!loading && !hasStats && (
        <div className="skeleton-grid">
          <SkeletonLoader type="card" count={4} />
          <SkeletonLoader type="card" count={3} />
        </div>
      )}
    </div>
  );
}

export default StatsLastMonth;
